<template>
    <Handle type="target" :position="Position.Left" id="input" />
    <NodeBase title="Delay" icon="⏱" color="#16a34a">
        <label>Duration (ms)</label>
        <input type="number" min="0" step="50"
            :value="props.data.duration ?? 500"
            @input="update('duration', parseInt($event.target.value) || 0)" />
    </NodeBase>
    <Handle type="source" :position="Position.Right" id="output" />
</template>

<script setup>
defineOptions({ inheritAttrs: false });
import { Handle, Position, useVueFlow } from '@vue-flow/core';
import NodeBase from './NodeBase.vue';

const props = defineProps({ id: String, data: Object });
const { updateNodeData } = useVueFlow();
const update = (key, val) => updateNodeData(props.id, { ...props.data, [key]: val });
</script>
